import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const Header = styled.header`
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 24px;
    min-height: 80px;
`;

export const LogoImage = styled.img`
    max-height: 48px;
    max-width: 180px;
    object-fit: contain;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
`;

export const HeroSection = styled.div`
    width: 100%;
    padding: 8px 24px 4px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 26px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
    line-height: 1.3;

    strong {
        font-weight: 800;
    }
`;

export const DocumentsSection = styled.div`
    width: 100%;
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Description = styled.p`
    font-size: 14px;
    color: #718096;
    margin: 0;
`;

export const DocumentsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const DocumentCard = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
`;

export const DocumentIconWrapper = styled.div<{ $accentColor?: string }>`
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const DocumentTitle = styled.span`
    font-size: 14px;
    font-weight: 500;
    margin-left: -8px;
    color: #717784;
    line-height: 1.4;
`;

export const FooterSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 16px 20px;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    flex-shrink: 0;
`;
